import { clsx } from 'clsx'

import { FC } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'

import { useSignUpMutation } from '@/app/graphql/generated'
import { getColorBtnSite, getColorSite } from '@/app/shared/components/modals/modal/services'
import { SelectPhoneComponent } from '@/app/shared/components/select-phone'
import useTailwindColor from '@/app/shared/hooks/useTailwindColor'
import { validation } from '@/app/shared/services/validation'
import useLayout, { ITypeSite } from '@/app/shared/store/layout.store'
import { buildUtmTags } from '@/app/shared/lib/attribution'
import { trackApplicationSend } from '@/app/shared/lib/analytics'
import { useMarkersStore } from '@/app/shared/store/markers.store'
import useModal from '@/app/shared/store/modals.store'
import { ButtonComponent } from '@/app/shared/ui/button'
import { InputComponent } from '@/app/shared/ui/input'
import { LoadingComponent } from '@/app/shared/ui/loading'
import { TitleComponent } from '@/app/shared/ui/title'
import { customToast } from '@/core/lib/react-toast'

import { ContentComponent } from '../content'

// interface
interface ISignUpCall {
  onClose: () => void
  title?: string
  typeSite: ITypeSite | null
}

interface IForm {
  name: string
  phone: string
}

// component
const SignUpCallComponent: FC<Readonly<ISignUpCall>> = ({ onClose, title, typeSite }) => {
  const landing = useLayout((state) => state.landing)
  const markers = useMarkersStore((state) => state.markers)

  const { getColor } = useTailwindColor()
  const { open } = useModal((store) => store)

  const currentTitle = title || 'Запишіться на дзвінок'

  const methods = useForm<IForm>({
    defaultValues: {
      name: '',
      phone: '',
    },
  })
  const [mutate, { loading }] = useSignUpMutation({
    onCompleted: () => {
      // customToast(data.createRequest?.message ?? '', 'success')

      onClose()
      setTimeout(() => {
        open({
          component: () => (
            <ContentComponent
              title='Дякуємо!'
              content='Заявку отримано — наш менеджер незабаром з вами зв’яжеться.'
            />
          ),
        })
      }, 500)
      trackApplicationSend()
    },
  })

  const handleSubmitForm = async (data: IForm) => {

    if (!landing) return

    await mutate({
      variables: {
        input: {
          full_name: data.name,
          phone: data.phone.replace(/\D/g, ''),
          landing_id: +landing.id,
          is_lessons: false,
          utm_tags: JSON.stringify(buildUtmTags(markers)),
        },
      },
    })
  }

  // return
  return (
    <div className={'overflow-visible'}>
      <TitleComponent
        className={'mb-[30px] 2xl:mb-[60px]'}
        classSize={'text-[28px] extraMobile:text-[34px]'}
      >
        {currentTitle}
      </TitleComponent>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmitForm)} className={clsx('grid gap-[50px]')}>
          <div className={'grid gap-[40px]'}>
            <Controller
              name={'name'}
              rules={{
                required: validation().required,
              }}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <InputComponent
                  onChange={onChange}
                  value={value}
                  isInvalid={Boolean(error)}
                  errorMessage={error?.message}
                  placeholder={"Ваше ім'я"}
                  colorType={getColorBtnSite(typeSite)}
                />
              )}
            />
            <SelectPhoneComponent
              name={'phone'}
              className={'mb-3'}
              isRequired
              colorType={getColorSite(typeSite, getColor)}
            />
          </div>
          <ButtonComponent
            type={'submit'}
            color={getColorBtnSite(typeSite)}
            className={'mx-auto w-fit'}
            size={'md'}
            isLoading={loading}
          >
            подзвонити мені
          </ButtonComponent>
        </form>
        <LoadingComponent isShow={loading} />
      </FormProvider>
    </div>
  )
}

SignUpCallComponent.displayName = 'SignUpCallComponent'

export default SignUpCallComponent
